/**
 * 静态地址
 */

// 官网地址

export const RELATED_PRODUCT = {
  curSource: "mj",
  PROD_WALLPAPER: {
    url: "https://www.ydesk.cn/?from=mj",
    soft_id: "wallpaper_win",
    oriname: "123wallpaper/123wallpaper.exe",
    softname: "123wallpaper.exe",
  }, // 壁纸
};

// 发票地址
export const invoiceUrl = "https://invoice.hoposoft.com";
// 客服地址
export const serviceUrl = "https://work.weixin.qq.com/kfid/kfc8ba8516cc2a36cad";
// "https://embed.shared.chatnote.com.cn/doc/#/embed?p=1734017177004019712";

// QQ群地址
export const qqGroupUrl = "https://qm.qq.com/q/TTdAQNtSEi";

// 画夹QQ群
export const ablumQQGroupUrl = "https://qm.qq.com/q/3FmcM6BfTW";

// 教程地址
export const tutorialUrl = "https://www.midjourny.cn/tutorial/index.html";

// 更新日志
export const updateLog = "https://doc.pcdashi.cn/web/#/102/517";

// 会员协议
export const memberAgreement = "https://doc.pcdashi.cn/web/#/455";
export const memberContractUrl = "https://doc.pcdashi.cn/web/#/462/2409";

// rules
export const rulesUrl =
  "https://docs.qq.com/doc/DVmZPV2lhU3NNQXFk?u=4d56b2e37ade4cb1a48861783380b1a5";

// 本地及测试地址
export const testList = ["http://local.pcdashi.cn"];

// gpt 接口域名
export const gptDomain = process.env.VUE_APP_CHAT_STREAM_URL as string;

// 图片域名
export const showImgDomain = "https://static.midjourny.cn";
export const needJoin = [
  "/cdnImages/preinstall",
  "/cdnImages/recommend",
  "/cdnImages/template",
  "/cdnImages/recomend",
];

export const feedbackUrl = "https://support.qq.com/products/624748";

// discord图片域名
export const discordImgDomain = "https://cdn.discordapp.com";
// 图片cdn域名
export const imgCdnDomain = "https://cdn.mij.asia";
// 视频cdn域名
export const videoCdnDomain = "https://video.midjourny.cn/";

/**
 * api地址
 */
// axios接口域名
export const allBaseUrl: any = {
  qnwApi: { url: process.env.VUE_APP_QNW_DOMAIN as string, isEncode: false },
  gptApi: { url: gptDomain, isEncode: true },
  similarityApi: { url: "https://similarity.midjourny.cn/", isEncode: true },
  custom: { url: "", isEncode: false },
};

// 微信登录接口域名
export const wxLoginUrl = "https://appcloud.api.pcdashi.cn/api/wechat/oauth";

// dall3及咒语生成流式输出接口
export const gptApi = `${gptDomain}/api/v2/app-community-v2`;

// 移动端支付接口域名
export const mobilePayUrl = "https://api.360qnw.com";

// 微信移动端支付接口域名
export const wxMobilePayUrl = "https://api.360qnw.com";
